import { parseHeroScheduleTime } from './islander-hero-schedule.js';

export function getMaintenanceState({ mode, start, end }, now = Date.now()) {
  if (mode === 'on') return { active: true, valid: true, nextChange: null };
  if (mode !== 'scheduled') return { active: false, valid: true, nextChange: null };
  const startsAt = parseHeroScheduleTime(start);
  const endsAt = parseHeroScheduleTime(end);
  if (!Number.isFinite(startsAt) || !Number.isFinite(endsAt) || endsAt <= startsAt) {
    return { active: false, valid: false, nextChange: null };
  }
  return {
    active: now >= startsAt && now < endsAt,
    valid: true,
    nextChange: now < startsAt ? startsAt : now < endsAt ? endsAt : null,
  };
}

if (typeof document !== 'undefined') {
  const config = document.querySelector('script[data-islander-maintenance]');
  const screen = document.querySelector('[data-maintenance-screen]');
  if (config && screen) {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      const state = getMaintenanceState(config.dataset);
      const previous = document.documentElement.dataset.maintenanceActive === 'true';
      document.documentElement.dataset.maintenanceActive = String(state.active);
      delete document.documentElement.dataset.maintenanceChecking;
      screen.hidden = !state.active;
      const reopening = screen.querySelector('[data-maintenance-reopening]');
      if (reopening && !reopening.textContent.trim() && config.dataset.mode === 'scheduled' && state.valid) {
        reopening.textContent = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', dateStyle: 'full', timeStyle: 'short' }).format(parseHeroScheduleTime(config.dataset.end)) + ' (UK time)';
      }
      if (state.active && !previous && screen.contains(document.activeElement) === false) screen.focus({ preventScroll: true });
      if (previous && !state.active) document.querySelector('#MainContent')?.focus({ preventScroll: true });
      if (!state.valid && config.dataset.editor === 'true') console.warn('Maintenance schedule is invalid. Storefront remains open. Use YYYY-MM-DD HH:MM in UK time.');
      if (state.nextChange !== null) timer = setTimeout(refresh, Math.min(60000, Math.max(100, state.nextChange - Date.now())));
    };
    refresh();
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
  }
}
